<nav class="navbar navbar-fixed-top admin-navbar">
        <div class="container-fluid">
            <div class="navbar-header">
                <i class="fa fa-bars" id="menu_icon" aria-hidden="true"></i> 
                <div class="header-title">TransMonitor</div>
                <span class="float-content-left">
                    <svg xmlns="http://www.w3.org/2000/svg" style="color: #979797" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                    </svg>                    
                    <input type="text" class="form-control search-field" placeholder="Search..." aria-label="Username" aria-describedby="basic-addon1">
                </span>
            </div>
            
            <div class="dropdown pull-right">
                 
                <div class="drop-container">
                    <a class="link">Support</a>
                    <a class="link"> FAQ</a>
                    <span class="link" style="position: relative">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16">
                            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
                        </svg>
                        <span class="badge bg-primary rounded-pill">1</span>
                    </span>
                </div>
                <div class="name-cont pull-right">
                        <div class="float-left">
                            <div class="hello">Hello</div>
                            <div class="username">Oluwaleke Ojo</div>
                        </div>
                        <img class="avatar float-right" src="../../../assets/man.png">
                </div>
                <!-- <button class="notification-btn dropdown-toggle" type="button" id="menu1" data-toggle="dropdown">
                  <i class="fa fa-bell-o" aria-hidden="true"></i><span class="badge">5</span>
                  </button> -->
  
                <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">
                    <h4 class="card-title-text">Notifications <a href="#" class="notifications_title pull-right">3 new Notifications</a></h4>
                    <li class="list-group-item unread">
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left avatar-img40x40">
                                    <img src="https://lh3.googleusercontent.com/-uwagl9sPHag/WM7WQa00ynI/AAAAAAAADso/ZGTVC0LVk1cFReheTbZzpGa2aawWyV8QACL0B/w140-d-h148-p-rw/profile-pic.jpg" class="media-object" style="width: 45px;margin-top: 2px;">
                                </div>
                                <div class="media-body">
                                    <h4 class="media-heading">John Doe</h4>
                                    <p>Lorem ipsum...</p>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li class="list-group-item unread">
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left avatar-img40x40">
                                    <img src="https://lh3.googleusercontent.com/-uwagl9sPHag/WM7WQa00ynI/AAAAAAAADso/ZGTVC0LVk1cFReheTbZzpGa2aawWyV8QACL0B/w140-d-h148-p-rw/profile-pic.jpg" class="media-object" style="width: 45px;margin-top: 2px;">
                                </div>
                                <div class="media-body">
                                    <h4 class="media-heading">John Doe</h4>
                                    <p>Lorem ipsum...</p>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li class="list-group-item unread">
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left avatar-img40x40">
                                    <img src="https://lh3.googleusercontent.com/-uwagl9sPHag/WM7WQa00ynI/AAAAAAAADso/ZGTVC0LVk1cFReheTbZzpGa2aawWyV8QACL0B/w140-d-h148-p-rw/profile-pic.jpg" class="media-object" style="width: 45px;margin-top: 2px;">
                                </div>
                                <div class="media-body">
                                    <h4 class="media-heading">John Doe</h4>
                                    <p>Lorem ipsum...</p>
                                </div>
                            </div>
                        </a>
                    </li>
                    <li class="list-group-item unread">
                        <a href="javascript:void(0)">
                            <div class="media">
                                <div class="media-left avatar-img40x40">
                                    <img src="https://lh3.googleusercontent.com/-uwagl9sPHag/WM7WQa00ynI/AAAAAAAADso/ZGTVC0LVk1cFReheTbZzpGa2aawWyV8QACL0B/w140-d-h148-p-rw/profile-pic.jpg" class="media-object" style="width: 45px;margin-top: 2px;">
                                </div>
                                <div class="media-body">
                                    <h4 class="media-heading">John Doe</h4>
                                    <p>Lorem ipsum...</p>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>